import moment from 'moment'

export const formatHeartbeatTimestamp = last_heartbeat =>
    last_heartbeat ? moment(last_heartbeat).format('DD.MM.YYYY - HH:mm') : '--'
